import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { MetaData } from "../components";


class PageNotFound extends Component {

    componentDidMount() {
        const {staticContext} = this.props;
        if (staticContext) {
            staticContext.is404 = true;
            staticContext.status = 404;
        }
    }

    render() {
        return (
            <div>
                <MetaData page="notFound" />
                <h1>Page Not Found</h1>
                <p>Go back <Link to='/discover'>home</Link></p>
            </div>
        )
    }

}

export default withRouter(PageNotFound)


// WEBPACK FOOTER //
// ./src/js/views/PageNotFound.js